import React, { useEffect, useState } from "react";
import moment from "moment/moment";
import { CUSTOM } from "../../constants/OptionsConstants"
import { defaultSelectOptions } from "../../constants/DatePickerSelectOptions";
import DateRangeCalendar from "./DateRangeCalendar";

const DatePickerWithOptions = ({
  selectMenuOptions = defaultSelectOptions,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  disableCustomDate,
  initialMonths
}) => {

  const [months, setMonths] = useState(initialMonths ||
    { value: 4, label: "Last 30 days" },
  );

  const handleSetDate = (from, to) => {
    setStartDate(from);
    setEndDate(to);

    setMonths({
      value: 99,
      label: CUSTOM,
    });
  };

  const handleOptionSelect = (value) => {
    let startDate = new Date();
    let endDate = new Date();

    switch (value.value) {
      case 2:
        startDate = moment(startDate).utc().subtract(6, "days").startOf("day");
        endDate = moment().endOf("day")
        break;
      case 3:
        startDate = moment(startDate).utc().subtract(27, "day").startOf("day");
        endDate = moment(endDate).endOf("day")
        break;

      case 4:
        startDate = moment(startDate).utc().subtract(29, "day").startOf("day");
        endDate = moment(endDate).endOf("day")
        break;
      case 5:
        startDate = moment(startDate).utc().subtract(89, "day").startOf("day");
        endDate = moment(endDate).endOf("day")
        break;
      case 6:
        startDate = moment(startDate).utc().subtract(12, "month");
        endDate = moment(endDate).endOf("day")
        break;
      case 7:
        startDate = moment(startDate).utc().subtract(1, "year").startOf("year");
        endDate = moment(endDate).utc().subtract(1, "year").endOf("year");
        break;


      case 98:
        startDate = moment(startDate).utc().startOf("month");
        endDate = moment(endDate).endOf("day")
        break;
      case 97:
        startDate = moment().utc().subtract(1, "month").startOf("month");
        endDate = moment().subtract(1, "month").endOf("month")
        break;
      case 96:
        startDate = moment().utc().subtract(3, "month").startOf("month");
        endDate = moment().subtract(1, "month").endOf("month");
        break;
      case 95:
        startDate = moment().utc().subtract(6, "month").startOf("month");
        endDate = moment().subtract(1, "month").endOf("month")
        break;
      case 94:
        startDate = moment().utc().subtract(1, "year").startOf("month");
        endDate = moment().endOf("month")
        break;

      default:
        break;
    }

    setMonths(value);
    setStartDate(new Date(startDate));
    setEndDate(new Date(endDate));
  };

  useEffect(() => {
    if (!startDate && !endDate) {
      setMonths({
        value: 99,
        label: CUSTOM,
      });
    }
  }, [startDate, endDate]);

  const presets = selectMenuOptions.map((option) => ({
    label: option.label,
    isActive: months?.value === option.value,
    onSelect: () => handleOptionSelect(option),
  }));

  return (
    <DateRangeCalendar
      startDate={startDate}
      endDate={endDate}
      onApply={handleSetDate}
      presets={presets}
      hideCalendarGrid={disableCustomDate}
    />
  );
};

export default DatePickerWithOptions;
